export enum RelativeDateFilter {
  /** Classes starting on or after today
   *  Two strings to differentiate between new or old relative choices
   */
  ThisWeek = "ThisWeek",
  AllUpcoming = "AllUpcoming",
  /** Classes starting on or after next Monday */
  NextWeek = "NextWeek",
  /** Classes starting on or after the first day of the next month */
  NextMonth = "NextMonth",
  /** Classes starting today */
  Today = "Today",
  /** Classes starting in the next 7 days */
  SevenDays = "SevenDays",
  /** Classes starting in the next 14 days */
  FourteenDays = "FourteenDays",
  /** Classes starting today or June 1 and ending August 31 */
  Summer = "Summer",
  /** Classes starting today or September 1 and ending November 30 */
  Fall = "Fall",
  /** Classes starting in January */
  January = "January"
}
